import { endOfMonth, startOfMonth, subDays } from 'date-fns';
import config from './reportConfig.json';

export const getReportConfig = (reportType) => {
  return config[reportType] || {};
};

export const getFilterOptions = (reportType) => {
  return Object.keys(config[reportType]?.filters || {});
};

export const getOperations = (reportType, filterBy) => {
  return config[reportType]?.filters?.[filterBy]?.operations || [];
};

export const getFilterType = (reportType, filterBy) => {
  return config[reportType]?.filters?.[filterBy]?.type || "multi";
};

export const getFilterSource = (reportType, filterBy) => {
  return config[reportType]?.filters?.[filterBy]?.source;
};

export const getFilterApiKey = (reportType, filterBy) => {
  return config[reportType]?.filters?.[filterBy]?.apiKey;
};

export const getFilterFieldType = (reportType, filterBy) => {
  return config[reportType]?.filters?.[filterBy]?.fieldType || 'dropdown';
};

export const getOperationApiValue = (reportType, operation) => {
  return config[reportType]?.operationMap?.[operation] || operation.toLowerCase();
};

export const getfields = (reportType) => {
  return config[reportType]?.fields;
};

export const reportDatePresets = [
  { label: 'Today', range: { startDate: new Date(), endDate: new Date() } },
  {
    label: 'Yesterday',
    range: {
      startDate: subDays(new Date(), 1),
      endDate: subDays(new Date(), 1),
    },
  },
  {
    label: 'Last Week',
    range: { startDate: subDays(new Date(), 7), endDate: new Date() },
  },
  {
    label: 'Last Month',
    range: {
      startDate: startOfMonth(subDays(new Date(), 30)),
      endDate: endOfMonth(subDays(new Date(), 30)),
    },
  },
];

export const weekDays = [
  {
    label: "Sunday",
    value: 0
  }, {
    label: "Monday",
    value: 1
  }, {
    label: "Tuesday",
    value: 2
  }, {
    label: "Wednesday",
    value: 3
  }, {
    label: "Thursday",
    value: 4
  }, {
    label: "Friday",
    value: 5
  }, {
    label: "Saturday",
    value: 6
  }
];

export const dayLabels = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday"
};